
export const storageInitializeAutomaticPlayback = () => {
    sessionStorage.setItem('automatic-playback-deeplink','true')
}

export const storageResetAutomaticPlayback= () => {
    sessionStorage.removeItem('automatic-playback-deeplink')
}

export const storageAutomaticPlaybackGet = ()=> {
    const automaticPlayback = sessionStorage.getItem('automatic-playback-deeplink');
    return automaticPlayback;
}

export const isDeepLink = () => {
    if (location.hash.includes('popGId')) return true;
    return false;
  };
